import { snakeCase } from "./strings";

interface FieldError {
  field: string;
  messages: string[];
}

export function getFormError(data: FieldError[] | undefined, values: Record<string, unknown>) {
  if (data && data.length > 0) {
    let fieldData: any = [];
    for (const key in values) {
      const error = data.find((item: FieldError) => {
        return item.field === key && item.messages.length > 0;
      });

      fieldData = [
        ...fieldData,
        {
          name: key,
          value: values[key],
          errors: error?.messages || [],
        },
      ];
    }

    return fieldData;
  }
}
export function getFormSnakeCaseError(data: FieldError[] | undefined, values: Record<string, unknown>) {
  if (data && data.length > 0) {
    let fieldData: any = [];
    for (const key in values) {
      const error = data.find((item: FieldError) => {
        return item.field === snakeCase(key) && item.messages.length > 0;
      });

      fieldData = [
        ...fieldData,
        {
          name: key,
          value: values[key],
          errors: error?.messages || [],
        },
      ];
    }

    return fieldData;
  }
}

interface GetFormListErrorsInputProps {
  data: FieldError[] | undefined;
  values: Record<string, unknown>;
  formList: string;
  formListIndex: number;
}

export function getFormListErrorsInput({
  data,
  values,
  formList,
  formListIndex,
}: GetFormListErrorsInputProps): any[] | undefined {
  if ((data?.length ?? 0) > 0) {
    let fieldData: any[] = [];
    for (const prop in values) {
      const error = data!.find((item: FieldError) => {
        return item.field === prop && item.messages.length > 0;
      });
      fieldData = [
        ...fieldData,
        {
          name: [formList, formListIndex, prop],
          value: values[prop],
          touched: true,
          errors: error ? error.messages : [],
        },
      ];
    }

    return fieldData;
  }
}
